/**
 * Locations page map
 */

import Axios from 'axios';
import Vue from 'vue';

export default new Vue({

	/** instance data */
	data() {
		return {

			/** @type {String|Null} current mode. set to search when displaying search results. */
			mode: 'loading',

			/** @type {Map} google maps instance */
			map: null,

			/** @type {Number} default zoom level */
			mapZoom: 6,

			/** @type {Object} default center location */
			mapCenter: {lat: 32.59558, lng: -99.35868},

			/** @type {Object} map marker icon */
			mapIcon: {
				url: '/wp-content/themes/slowdough/assets/dist/img/map-marker.png',
			},

			/** @type {Array} all available locales and their locations */
			locales: [],

			/** @type {Array} map styles */
			mapStyles: [
				{
					featureType: 'poi.business',
					stylers: [{visibility: 'off'}]
				}
			],

			/** @type {InfoWindow} info window */
			infoWindow: null,

			/** @type {String} zipcode search query */
			query: '',

			/** @type {String} are we currently performing a search request */
			searching: false,

			/** @type {Number} number of markers currently showing within map viewport bounds */
			visibleMarkers: 0,

		};
	},

	/**
	 * Instance mounted hook
	 */
	mounted() {
		this.map = new google.maps.Map(this.$refs.map, {
			zoom: this.mapZoom,
			center: this.mapCenter,
			disableDefaultUI: true,
			styles: this.mapStyles,
		});

		this.map.addListener('idle', () => this.setItemVisibility());

		this.mapIcon.scaledSize = new google.maps.Size(20, 26);

		this.infoWindow = new google.maps.InfoWindow();

		this.loadItems();
	},

	/** @type {Object} instance methods */
	methods: {
		/**
		 * Load the locations
		 */
		loadItems() {
			Axios.get('/wp-json/slowdough/locations')
				.then(response => { this.populate(response.data) })
				.catch(err => console.error('Error retrieving locations data.'))
				.then(() => this.mode = null);
		},

		/**
		 * Populate the items array
		 *
		 * @param  {Array} items
		 */
		populate(locales) {
			this.locales = locales;

			this.locales.forEach(locale => {
				locale.locations.forEach(item => {
					item.latLng = new google.maps.LatLng(item.latitude, item.longitude);
					this.addMarker(item);
				});
			});
		},

		/**
		 * Add a marker to an item
		 *
		 * @param {Object} item location item
		 */
		addMarker(item) {
			item.marker = new google.maps.Marker({
				position: {
					lat: item.latitude,
					lng: item.longitude
				},
				map: this.map,
				icon: this.mapIcon,
			});

			item.marker.addListener('click', event => this.showInfo(item));
		},

		/**
		 * Show a location's info window
		 * @param  {item} item location item
		 */
		showInfo(item) {
			const content = this.$refs['location-' + item.id][0].innerHTML;

			this.infoWindow.setPosition(item.latLng);
			this.infoWindow.setContent('<div class="location-infowindow">' + content + '</div>');

			this.infoWindow.open(this.map, item.marker);
		},

		/**
		 * Handle a zipcode search
		 */
		search() {
			if(this.query.length !== 5 || this.searching) return;

			const geocoder = new google.maps.Geocoder();

			this.searching = true;

			geocoder.geocode({
				address: this.query + ' USA'
			}, (results, status) => {
				if(status == 'OK') {
					this.map.setCenter(results[0].geometry.location);
					this.map.setZoom(12);
				} else {
					console.error('Search query not successful: ' + status);
				}

				this.searching = false;
				this.mode = 'search';
			});
		},

		/**
		 * Reset the map view
		 * Currently this only resets the zoom and mode, it does not return to the original
		 * center position.
		 */
		reset(recenter = false) {
			this.query = '';
			this.mode = null;
			this.map.setZoom(this.mapZoom);

			if(recenter) this.map.setCenter(this.mapCenter);
		},

		/**
		 * Sets item visibility
		 */
		setItemVisibility() {
			const bounds = this.map.getBounds();
			let visibleMarkers = 0;

			this.locales.forEach((locale, index) => {
				let visibleItems = 0;

				locale.locations.forEach(item => {
					item.visible = bounds.contains(item.latLng);

					if(item.visible) {
						visibleMarkers++;
						visibleItems++;
					}
				});

				locale.visible = visibleItems;
				this.locales[index] = locale;
			})

			this.visibleMarkers = visibleMarkers;

			this.$forceUpdate(); // seems legit.
		},
	}

});
